import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { FaTimes, FaAngleRight, FaAngleDown } from 'react-icons/fa';
import { AuthContext } from '@context';
import useMyMenus from '@hooks/comm/useMyMenus';
import './MobileMenu.css';

const MobileMenu = ({ isMobileMenuOpen, toggleMobileMenu }) => {
  const { auth } = useContext(AuthContext);
  const { data: myMenus = [] } = useMyMenus(auth.isAuthenticated);
  const [expandedMenu, setExpandedMenu] = useState(null);

  const handleMenuClick = (menuCode) => {
    setExpandedMenu(expandedMenu === menuCode ? null : menuCode);
  };

  if (!isMobileMenuOpen) return null;

  return (
    <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
      <div className="mobile-menu-header">
        <h5>메뉴</h5>
        <FaTimes className="close-icon" onClick={toggleMobileMenu} />
      </div>
      <ul className="mobile-menu-list">
        {myMenus.map((menu) => {
          const hasChildren = menu.children && menu.children.length > 0;
          const isExpanded = expandedMenu === menu.menuCode;

          return (
            <li key={menu.menuCode}>
              {!hasChildren && menu.path ? (
                <Link to={menu.path} onClick={toggleMobileMenu} className="mobile-menu-direct-link">
                  {menu.menuName}
                </Link>
              ) : (
                <>
                  <button type="button" onClick={() => handleMenuClick(menu.menuCode)}>
                    {menu.menuName}
                    {isExpanded
                      ? <FaAngleDown className="submenu-icon float-right mt-1" />
                      : <FaAngleRight className="submenu-icon float-right mt-1" />
                    }
                  </button>
                  <ul className="mobile-submenu-list" style={{ display: isExpanded ? 'block' : 'none' }}>
                    {menu.children?.map((child) => (
                      <li key={child.menuCode}>
                        <Link to={child.path} onClick={toggleMobileMenu}>
                          <FaAngleRight className="submenu-icon" /> {child.menuName}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MobileMenu;
